import type { IconData } from '@stacksjs/iconify-core'

export const imageSaturationSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M43.5 27.889C43.5 38.239 34.697 46.5 24 46.5S4.5 38.238 4.5 27.889c0-5.598 3.258-10.998 6.843-15.29c3.626-4.339 7.805-7.801 10.075-9.552a4.214 4.214 0 0 1 5.164 0c2.27 1.75 6.45 5.213 10.075 9.552c3.585 4.292 6.843 9.692 6.843 15.29M24 12.96a.477.477 0 0 0-.768-.39C20.734 14.487 13 20.947 13 27.406c0 5.526 4.394 10.064 10 10.55c.55.048 1-.405 1-.957z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default imageSaturationSolid
